import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import _get from "lodash/get";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { defaultProps, propTypes } from './api';
import { wrapWithAlign } from './BaseTable';
import styles from './TableSimple.module.less';
export var TableSimple = function TableSimple(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      data = _ref.data,
      hasTableHeader = _ref.hasTableHeader,
      rowHover = _ref.rowHover,
      ariaLabel = _ref['aria-label'],
      ariaLabelledBy = _ref['aria-labelledby'],
      otherProps = _objectWithoutProperties(_ref, ["className", "columns", "data", "hasTableHeader", "rowHover", "aria-label", "aria-labelledby"]);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tableBorder, styles.borderless)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tableSimple, _defineProperty({}, styles.rowHover, rowHover), className)
  }, /*#__PURE__*/React.createElement("table", _extends({
    className: styles.table,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy // All components need to be keyboard usable, `tabIndex="0"`
    // is a rare acceptable exception
    // https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable?application=axeAPI
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: "0"
  }, otherProps), hasTableHeader && /*#__PURE__*/React.createElement("thead", {
    className: styles.thead
  }, /*#__PURE__*/React.createElement("tr", {
    className: styles.tr
  }, columns.map(function (column) {
    return /*#__PURE__*/React.createElement("th", {
      key: column.id,
      className: styles.th,
      style: {
        minWidth: column.minWidth
      },
      scope: "col"
    }, wrapWithAlign(column.align, column.heading));
  }))), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row) {
    return /*#__PURE__*/React.createElement("tr", {
      key: row.key,
      className: styles.tr
    }, columns.map(function (column) {
      return /*#__PURE__*/React.createElement("td", {
        className: styles.td,
        key: column.id
      }, wrapWithAlign(row.align || column.align, _get(row, column.id)));
    }));
  })))));
};
TableSimple.propTypes = propTypes;
TableSimple.defaultProps = defaultProps;